<template>
	<div class="see_more" @click="seemore">
		<p class="hoverClass">{{ '<<<查看更多>>>' }}</p>
	</div>
</template>

<script>
	export default{
		methods:{
			seemore(){
				this.$emit("seemore")
			}
		}
	}
</script>

<style lang="scss" scoped>
	.see_more{
		margin-top: 1.25rem;
		color: #D1010F;
		font-size: 0.8rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>